import React from 'react';
import ReactDOM from 'react-dom/client';
import {Accordion} from "./content-elements/Accordion.jsx";

const elements = document.querySelectorAll('.um-accordion')

elements.forEach((element, index) => {
    const root = ReactDOM.createRoot(element)
    let titleTag = "h3"
    if (element.dataset.tag) {
        titleTag = element.dataset.tag
    }
    root.render(
        React.createElement(React.StrictMode, null,
            React.createElement(Accordion, {children: element.children, index: index, titleTag: titleTag})
        )
    )
})
